var _circle, _g, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTopCategoryList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    fill: "#CCCDD3",
    fillOpacity: 0.62
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1221_3559)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5477 6.79248H4.23162C3.82756 6.79248 3.5 7.12004 3.5 7.5241C3.5 7.92816 3.82756 8.25571 4.23162 8.25571H11.5477C11.9518 8.25571 12.2793 7.92816 12.2793 7.5241C12.2793 7.12004 11.9518 6.79248 11.5477 6.79248Z",
    fill: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5477 3.86572H4.23162C3.82756 3.86572 3.5 4.19328 3.5 4.59734C3.5 5.0014 3.82756 5.32895 4.23162 5.32895H11.5477C11.9518 5.32895 12.2793 5.0014 12.2793 4.59734C12.2793 4.19328 11.9518 3.86572 11.5477 3.86572Z",
    fill: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.62127 9.71875H4.23162C3.82756 9.71875 3.5 10.0463 3.5 10.4504C3.5 10.8544 3.82756 11.182 4.23162 11.182H8.62127C9.02533 11.182 9.35289 10.8544 9.35289 10.4504C9.35289 10.0463 9.02533 9.71875 8.62127 9.71875Z",
    fill: "#2D2D2D"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.138 10.1345C10.8714 9.97451 10.5322 10.1666 10.5322 10.4775V13.7939C10.5322 14.1048 10.8714 14.2968 11.138 14.1369L13.9017 12.4787C14.1606 12.3233 14.1606 11.948 13.9017 11.7927L11.138 10.1345Z",
    fill: "#2D2D2D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1221_3559"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.9741,
    height: 10.9741,
    fill: "white",
    transform: "translate(3.5 3.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopCategoryList);
export default __webpack_public_path__ + "static/media/top_category_list.86e0be0c48f2d01c56e4f64f99160d39.svg";
export { ForwardRef as ReactComponent };